import { Link } from "react-router-dom";

export const Footer = () => (
  <footer className="mt-24 border-t border-[var(--line-soft)] bg-[var(--bg-2)]">
    <div className="wrap flex flex-col gap-6 py-12 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-center gap-2.5 font-display text-lg text-[var(--text)]">
        <span className="paso-dot" />Da el <em className="text-[var(--alba-text)] italic">Paso</em>
      </div>
      <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-[var(--muted)]">
        <Link to="/privacidad" data-testid="footer-privacidad" className="hover:text-[var(--text)]">
          Privacidad
        </Link>
        <span>En español</span>
      </div>
    </div>
  </footer>
);
